export const SITE_URL = 'https://www.worldotutor.com';
export const SITE_NAME = 'WorldoTutor';
export const DEFAULT_IMAGE = `${SITE_URL}/imgi_1_favicon.png`;
